import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon?: string;
  svgIcon?: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MECHANIC_MENUITEMS: Menu[] = [
  {
    label: null,
    main: [
      {
        state: 'mechanichome',
        short_label: 'M',
        name: 'Mechanic Home',
        type: 'link',
        icon: 'ti-dashboard',
        svgIcon: 'assets/icons/sidebar/dashboard.svg'
      }
    ],
  }
];

const MENUITEMS: Menu[] = [
  {
    label: null,
    main: [
      {
        state: 'default',
        main_state: 'dashboard',
        short_label: 'D',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-home',
        svgIcon: 'assets/icons/sidebar/dashboard.svg'
      }
    ]
  },
  {
    label: 'JOBS',
    main: [
      {
        state: 'schedule',
        short_label: 'S',
        name: 'Job Schedule',
        type: 'link',
        icon: 'ti-calendar',
        svgIcon: 'assets/icons/sidebar/job-schedule.svg'
      },
      {
        state: 'joblist',
        short_label: 'L',
        name: 'Jobs',
        type: 'link',
        icon: 'ti-layout-list-thumb',
        svgIcon: 'assets/icons/sidebar/jobs.svg'
      },
      {
        state: 'jobview',
        short_label: 'V',
        name: 'Quick Job View',
        type: 'link',
        icon: 'ti-eye',
        svgIcon: 'assets/icons/sidebar/quick-job-view.svg'
      },
      {
        state: 'jobcomposer',
        short_label: 'C',
        name: 'Job Composer',
        type: 'link',
        icon: 'ti-pencil-alt',
        svgIcon: 'assets/icons/sidebar/job-composer.svg'
      },
      {
        state: 'jobtemplates',
        short_label: 'T',
        name: 'Job Templates',
        type: 'link',
        icon: 'ti-write',
        svgIcon: 'assets/icons/sidebar/job-templates.svg'
      },
      {
        state: 'invoicelist',
        short_label: 'P',
        name: 'Invoices',
        type: 'link',
        icon: 'ti-money',
        svgIcon: 'assets/icons/sidebar/invoices.svg'
      }
    ]
  },
  {
    label: 'QUOTES',
    main: [
      {
        state: 'quoteslist',
        short_label: 'Q',
        name: 'Quotation Jobs',
        type: 'link',
        icon: 'ti-write',
        svgIcon: 'assets/icons/sidebar/quotation-jobs.svg'
      },
      {
        state: 'quote',
        short_label: 'Q',
        name: 'Quick Quotation View',
        type: 'link',
        icon: 'ti-write',
        svgIcon: 'assets/icons/sidebar/quick-quotation-view.svg'
      }
    ]
  },
  {
    label: 'BUSINESS',
    main: [
      {
        state: 'booking-requests',
        short_label: 'R',
        name: 'Booking Requests',
        type: 'link',
        icon: 'ti-calendar',
        svgIcon: 'assets/icons/sidebar/booking-requests.svg'
      },
      {
        state: 'inventory',
        short_label: 'I',
        name: 'Inventory',
        type: 'sub',
        icon: 'ti-package',
        svgIcon: 'assets/icons/sidebar/inventory.svg',
        children: [
          {
            state: 'references',
            name: 'References'
          },
          {
            state: 'items',
            name: 'Item Inventory'
          },
          {
            state: 'kits',
            name: 'Kits'
          },
          {
            state: 'suppliers',
            name: 'Suppliers'
          },
          {
            state: 'purchase-orders',
            name: 'Purchase Orders'
          }
        ]
      },
      {
        state: 'business-profile',
        short_label: 'B',
        name: 'Business Profile',
        type: 'link',
        icon: 'ti-briefcase',
        svgIcon: 'assets/icons/sidebar/business-profile.svg'
      },
      {
        state: 'connections',
        short_label: 'C',
        name: 'Connections',
        type: 'link',
        icon: 'ti-link',
        svgIcon: 'assets/icons/sidebar/connections.svg'
      },
      {
        state: 'sysusers',
        short_label: 'U',
        name: 'System Users',
        type: 'link',
        icon: 'ti-user',
        svgIcon: 'assets/icons/sidebar/system-users.svg'
      },
      {
        state: 'customers',
        short_label: 'C',
        name: 'Customers & Vehicles',
        type: 'link',
        icon: 'ti-car',
        svgIcon: 'assets/icons/sidebar/customers-vehicles.svg'
      },
      {
        state: 'timesheet',
        short_label: 'T',
        name: 'Time Sheets',
        type: 'link',
        icon: 'ti-timer',
        svgIcon: 'assets/icons/sidebar/time-sheets.svg'
      }
    ]
  }
];

@Injectable({
  providedIn: 'root'
})
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }


  getMenuByUserType(): Menu[] {

    let userType = localStorage.getItem('role');

    if (userType == "Admin") {
      return MENUITEMS;
    }
    else if (userType == "Mechanic") {
      return MECHANIC_MENUITEMS;
    }
    else {
      return [];
    }

  }


  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}
